import authGuard from '@/router/auth-guard'

export default [
  {
    path: '/homeownerLease',
    name: 'homeownerLease',
    component: () =>
      import(/* webpackChunkName: "homeownerLease" */ '@/pages/Homeowner/lease/Information.vue'),
    beforeEnter: authGuard
  }
]
